/* eslint-disable no-unused-vars */
export const READABLE_DATE_OPTIONS = {
  weekday: "short",
  month: "short",
  day: "2-digit",
  timeZone: "UTC",
};

export const roleKey =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const timeframeOptions = [
  { value: "0", label: "Current Month" },
  { value: "1", label: "Last Month" },
  { value: "2", label: "Custom Range" },
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const currentYear = new Date().getFullYear();

export const currentMonth = new Date().getMonth() + 1;

export const getMonthOptions = () => {
  const currentMonthIndex = new Date().getMonth();
  return MONTHS.map((month, index) => ({
    value: index + 1,
    label: month,
    default: index === currentMonthIndex,
  }));
};

export const YEARS = Array.from(
  { length: currentYear - 1970 + 1 },
  (_, i) => currentYear - i
);

export const PAYMENT_METHODS = {
  ACH: "ACH",
  CHECK: "Check",
  WIRE: "Wire",
};

export const YYYYMMDD = 'YYYY-MM-DD';